import { get, isArray, isFunction, map, noop } from 'lodash'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

import Icon from '../../Icon'
import { TColumn, TRowData } from '../types'

interface MobileBodyProps extends TColumn {
  rowData?: TRowData
  isActionColumn?: boolean
}

interface MobileColumnProps {
  mobileCellHeader?: (val: MobileColumnProps) => React.ReactNode
  mobileCellBody?: (val: MobileColumnProps) => React.ReactNode
  mobileCellHeaderItems?: (val: MobileColumnProps) => any[]
  rowIndex?: number
  toggle?: (val?: number) => void
  isToggled?: boolean
  columns?: TColumn[]
  rowData?: TRowData
}

interface renderMobileFromColumnsProps {
  columns?: TColumn[]
  rowData?: TRowData
}

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Header = styled.div<{
  isToggled: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

const Body = styled.div`
  position: relative;
`

const MobileBody = (props: MobileBodyProps): React.ReactElement => {
  const {
    rowData,
    label,
    dataKey,
    cellRenderer = undefined,
    isActionColumn = false,
  } = props

  const cellData = !isArray(dataKey)
    ? get(rowData, `${dataKey}`, null)
    : rowData

  return isActionColumn ? (
    <Col xs="12">
      {cellRenderer ? (
        cellRenderer({ cellData, isMobile: true, rowData })
      ) : (
        <span>{get(rowData, `${dataKey}`, '-')}</span>
      )}
    </Col>
  ) : (
    <Row>
      <Col xs="4">
        <span className="font-weight-bold">{label}:</span>
      </Col>
      <Col xs="8">
        {cellRenderer ? (
          cellRenderer({ cellData, isMobile: true, rowData })
        ) : (
          <span>{get(rowData, `${dataKey}`, '-')}</span>
        )}
      </Col>
    </Row>
  )
}

const renderMobileFromColumns = ({
  columns,
  rowData,
}: renderMobileFromColumnsProps): React.ReactElement => {
  return (
    <React.Fragment>
      {map(columns, (col) => (
        <MobileBody
          rowData={rowData}
          label={col.label}
          dataKey={col.dataKey}
          cellRenderer={col.cellRenderer}
          isActionColumn={col.isActionColumn}
        />
      ))}
    </React.Fragment>
  )
}

const MobileColumn = (props: MobileColumnProps): React.ReactElement => {
  const {
    mobileCellHeader = () => <></>,
    mobileCellBody,
    mobileCellHeaderItems,
    rowIndex,
    toggle,
    isToggled = false,
    columns,
    rowData,
  } = props

  const onToggle = (): void => {
    if (toggle) {
      toggle(rowIndex)
    }
  }

  return (
    <Wrapper>
      <Header onClick={onToggle} isToggled={isToggled} className="pr-1 py-1">
        <div className="flex-fill d-flex">
          {mobileCellHeaderItems
            ? mobileCellHeaderItems(props).map(({ label, ...rest }, key) => (
                <div style={rest} key={key}>
                  {label}
                </div>
              ))
            : mobileCellHeader(props)}
        </div>
        <Icon icon={`fas fa-chevron-${isToggled ? 'up' : 'down'}`} />
      </Header>
      {isToggled && (
        <Body className="py-1">
          {isFunction(mobileCellBody)
            ? mobileCellBody(props)
            : renderMobileFromColumns(props)}
        </Body>
      )}
    </Wrapper>
  )
}
export default MobileColumn
